import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonVariants } from '@levelaccess/design-system';

@Component({
  selector: 'app-ds-confirmation-modal',
  templateUrl: './ds-confirmation-modal.component.html',
  styleUrls: ['./ds-confirmation-modal.component.scss'],
  standalone: false,
})
export class DsConfirmationModalComponent {
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  @Input() public title: string;
  @Input() public message: string;
  @Input() public description: string;
  @Input() public descriptionIsHTML: boolean;
  @Input() public confirmLabel: string;
  @Input() public cancelLabel: string;
  @Input() public hideCancelButton: boolean = false;
  @Input() public closeAllModals: boolean = true;
  @Input() public maxWidthPercentage: number;

  @Output() public confirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() public cancelled: EventEmitter<void> = new EventEmitter<void>();

  constructor(protected modal: NgbActiveModal) {}

  protected onCancel(): void {
    this.cancelled.emit();
    this.modal.dismiss();
  }

  protected onConfirm(): void {
    this.confirm.emit();
    this.modal.close();
  }

  protected onClose(): void {
    this.cancelled.emit();
  }
}
